import { Component, inject, OnInit } from '@angular/core';
import { VerifyTokenService } from './verify-token.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ICognitoAuth } from './verify-token.model';
import { AwsSignerService } from '../services/aws-signer.service';
import { AuthService } from '../services/auth.service';
import { JwtService } from '../services/jwt.service';
import { TbtStorageService } from '@app/shared/services/tbt-storage.service';

@Component({
  selector: 'app-verify-token',
  standalone: true,
  imports: [],
  templateUrl: './verify-token.component.html',
  styleUrl: './verify-token.component.scss',
})
export class VerifyTokenComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly tbtStorageService = inject(TbtStorageService);
  ngVerifyTokenService = inject(VerifyTokenService);
  authService = inject(AuthService);
  awsSignerService = inject(AwsSignerService);
  router = inject(Router);
  jwtService = inject(JwtService);

  verifyingToken = 'Verifying user, please wait...';
  loggingIn = 'logging in, please wait...';
  authSuccess = 'logging in successfully, please wait...';

  message = '';
  private accessToken = ''; // Obtained from Cognito

  ngOnInit() {

    const hashParams = this.parseHashFragment();

    if (hashParams['access_token']) {
      const accessToken = hashParams['access_token'];
      this.tbtStorageService.setItem('idp_id_token', accessToken, true);
      this.message = this.verifyingToken;
      this.invokeLambda();
    }

    // this.route.queryParams.subscribe((params) => {
    //   const authCode = params['access_token'];
    //   if (authCode) {
    //     this.tbtStorageService.setItem('idp_id_token', authCode, true);
    //     this.message = this.verifyingToken;
    //     this.invokeLambda();
    //   }
    // });
    // this.route.queryParams.subscribe((params) => {
    //   const authCode = params['code'];
    //   if (authCode) {
    //     this.message = this.verifyingToken;
    //     this.ngVerifyTokenService.getAccessToken(authCode).subscribe(
    //       (data: ICognitoAuth) => {
    //         this.tbtStorageService.setItem('idp_access_token', data.access_token, true);
    //         this.tbtStorageService.setItem('idp_id_token', data.id_token, true);
    //         this.accessToken = data.id_token;
    //         this.invokeLambda();
    //       },
    //       (error) => {
    //         console.error('Error getting access token:', error);
    //         this.message = 'Error getting access token';
    //       }
    //     );
    //   }
    // });
  }

  private parseHashFragment(): Record<string, string> {
    const hash = window.location.hash.substring(1); // Remove the '#'
    if (!hash) return {};

    return hash.split('&').reduce((params, param) => {
      const [key, value] = param.split('=');
      params[decodeURIComponent(key)] = decodeURIComponent(value || '');
      return params;
    }, {} as Record<string, string>);
  }

  logout() {
    // this.ngVerifyTokenService.logout();
  }

  async invokeLambda() {
    this.ngVerifyTokenService.getSFAuthToken().subscribe((data: any) => {
      if (data.statusCode === 200) {
        const { access_token, instance_url } = data.body;
        this.tbtStorageService.setItem('access_token', access_token, true);
        this.tbtStorageService.setItem('instance_url', instance_url, true);
      }
        this.message = this.authSuccess;
        // this.getUserRole(); // commeneted for migration purposes, will be uncommented once testing is done with the API
        this.getUserInforFromIapiToken();
    }, err => {
      console.log(err);
      this.message = 'Error invoking Lambda';
    });  
  }

  getUserInforFromIapiToken() {
    this.ngVerifyTokenService.getUserInfoFromIapiToken().subscribe({
      next: user => {
        console.log('User info from IAPI token: ', user);
        this.getUserRole(user.email);
      },
      error: error => {
        console.error('Error while getting user info from IAPI token: ', error);
      }
    });
  }

  getUserRole(user?: string) {
    // const user = this.jwtService.getUserEmail(); // commenting for the migration purposes
    // const user = 'appana.rama.lakshmi.nikhita@merck.com';

    if (!user) {
      user = 'sai.reddy1@msd.com'; // hardcoding the user email for now, as we are not able to get the email from the token decoded data. This needs to be removed once we are able to get the email from the token.
    }
    this.tbtStorageService.setItem('user_email', user, false); // TODO: Remove after migration

    this.authService.getUserRoleForTBT(user).subscribe(data => {
      if (data?.done) {
        const userRecords = data.records;
        if (userRecords?.length) {
          const role = userRecords[0].MSD_CORE_User_Role__c;
          const approverName = userRecords[0].MSD_CORE_HEQ_Approver_Id__c;
          this.authService.setUserRole(role);
          this.authService.setApproverName(approverName);
          this.ngVerifyTokenService.setUserRole(role);
          this.router.navigate(['/dashboard']);
        } else {
          this.message = `User: ${user} is not mapped any role. User should be Author or Approver to proceed. Try contacting your administrator and re-login to the TBT.`
        }
        
      }
    }, error => {
      // TOD: Remove this once the API is up:
      this.ngVerifyTokenService.setUserRole('Author');
      this.router.navigate(['/dashboard']);
      console.error('Error while getting the user role: ', error);
    });
  }

}
